<template>
  <template v-if="populatedForm?.fields">
    <mpf-form
      :form-title="populatedForm.config?.formTitle"
      :hint="populatedForm.config?.hint"
      :fields="populatedForm?.fields"
      @submit="(e) => handleSubmit(e)"
      submit-label="Continue"
    />
  </template>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useRouteMeta } from '../composables/useRouteMeta';
  import MpfForm from '../components/MpfForm/MpfForm.vue';
  import { useMedicalRequestStore } from '../../stores/useMedicalRequestStore';
  import { useAdminRequestStore } from '../../stores/useAdminRequestStore';
  import { router } from '../../router';
  import { useMergeDataIntoForm } from '../composables/useMergeDataIntoForm';
  import { useUrlSegments } from '../composables/useUrlSegments';
  import { MpfFormPropsWithConfig } from '../../types/router-meta';
  import { useRequestFormAvailability } from '../composables/useRequestFormAvailability';
  import { RequestType } from '../../types';

  const { formConfig } = useRouteMeta();
  const { firstSegment } = useUrlSegments();
  const { check } = useRequestFormAvailability();

  const medicalRequestStore = useMedicalRequestStore();
  const adminRequestStore = useAdminRequestStore();

  const handleSubmit = async (data: any) => {
    if (!data.valid) return;

    const formStatus = await check(firstSegment.value as RequestType);
    if (!formStatus) return;

    if (firstSegment.value === 'medical-request') {
      medicalRequestStore.setProblemDescription(data.values.problemDescription);
      medicalRequestStore.setProblemRecentContact(data.values.problemRecentContact);
      medicalRequestStore.addAttachments(data.values.attachments);
    } else if (firstSegment.value === 'admin-request') {
      adminRequestStore.setAdminRequest(data.values.adminRequest);
      adminRequestStore.addAttachments(data.values.attachments);
    }

    await router.push(`/${firstSegment.value}/summary`);
  };

  // TODO: IF NHS redirect, get tenant details, patient details, add to store ELSE
  // TODO: check can be here - if NO go back 1 or to start...

  const { mergeDataIntoForm } = useMergeDataIntoForm();

  const populatedForm = computed<MpfFormPropsWithConfig | null>(() => {
    const config = formConfig.value as MpfFormPropsWithConfig | undefined;
    if (!config) return null;
    return mergeDataIntoForm(config, firstSegment.value) ?? config;
  });
</script>
